import React from 'react'
import {
  DateInput,
  ImageUpload,
  ModalWrapper,
  SelectField,
  StyledButton,
  TextFields,
} from '../../../../../../../components'
import { useNavigate } from 'react-router-dom'
import { QRicon, phoneIcon } from '../../../../../../../assets/icons'
import { Avatar, Box, Checkbox, Divider, FormControlLabel, Typography } from '@mui/material'
import { SuccesAnimation } from '../../../../../../../assets/images'
import { useGlobal } from '../../../../../../../shared'
import { urls } from '../../../../../../../shared/config'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import QRCode from 'react-qr-code'
import { useDispatch } from 'react-redux'
import { setLoader } from '../../../../../../../redux/globalSlice'
import classes from './Buttons.module.css'

export const Buttons = ({ onNext, text, onPrev, student, skip }) => {
  const navigate = useNavigate()
  return (
    <div className="in-a-row" style={{ justifyContent: 'flex-end' }}>
      {skip && (
        <button onClick={onNext} className={classes.skip}>
          Skip
        </button>
      )}
      {!student &&
        (text ? (
          <Typography className="back-btn" onClick={onPrev}>
            {text}
          </Typography>
        ) : (
          <Typography className="back-btn" onClick={() => navigate('/dashboard')}>
            Back
          </Typography>
        ))}

      <StyledButton width={student ? '147px' : '50%'} student={student} onClick={onNext}>
        Next
      </StyledButton>
    </div>
  )
}

export const Step1 = ({ formik, onNext, handleFileChange }) => {
  const navigate = useNavigate()
  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, '')
    formik.setFieldValue(fieldName, numericValue)
  }
  const handleStringInputChange = (fieldName) => (e) => {
    const stringValue = e.target.value.replace(/[^a-zA-Z\s]/g, '')
    formik.setFieldValue(fieldName, stringValue)
  }
  const countryOptions = [
    {
      value: 'India',
      label: 'India',
    },
    {
      value: 'UAE',
      label: 'UAE',
    },
  ]
  const handleCountryChange = (value) => {
    formik.setFieldValue('school_country', value)
    // Set country codes based on selected country
    const code = value === 'India' ? '+91' : '+971'
    formik.setFieldValue('school_country_code', code)
    formik.setFieldValue('employee_country_code', code)
  }
  return (
    <div>
      <ImageUpload
        label={'School Logo'}
        selectedImage={
          formik.values.personalImage && URL.createObjectURL(formik.values.personalImage)
        }
        onFileChange={(event) => handleFileChange(event, 'personalImage')}
      />
      <div className="text-fields">
        <TextFields
          label={'School Name'}
          placeholder={'Enter School Name'}
          required
          width={'100%'}
          name="schoolName"
          value={formik.values.schoolName}
          onChange={formik.handleChange}
        />
        <TextFields
          name={'contactNumber'}
          label={'Contact Number'}
          placeholder={'1234567890'}
          required
          width={'100%'}
          value={formik.values.contactNumber}
          onChange={handleInputChange('contactNumber')}
        />
      </div>
      <div className="text-fields">
        <TextFields
          type="time"
          name={'school_staff_timing'}
          label={'School Staff Timing'}
          width={'100%'}
          placeholder={'Enter Staff Timing'}
          value={formik.values.school_staff_timing}
          onChange={formik.handleChange}
          required
        />
        <TextFields
          type="time"
          name={'school_timing'}
          label={'School Timing'}
          placeholder={'Enter School Timing'}
          width={'100%'}
          value={formik.values.school_timing}
          onChange={formik.handleChange}
          required
        />
      </div>
      <SelectField
        // placeholder={'Select School'}
        options={[
          { label: 'Annually', value: 'Annually' },
          { label: 'Monthly', value: 'Monthly' },
        ]}
        name="school_fee_method"
        value={formik.values.school_fee_method}
        // onChange={(val) => setFieldValue('school_fee_method', val)}
        onChange={(value) => formik.setFieldValue('school_fee_method', value)}
        width={'96.5%'}
        label={'Fees Timeline'}
        required
      />
      <div className="text-fields">
        <TextFields
          label={'School Address'}
          placeholder={'Enter School Address'}
          required
          width={'100%'}
          name="school_address"
          value={formik.values.school_address}
          onChange={formik.handleChange}
        />
        <TextFields
          label={'School City'}
          placeholder={'Enter School City'}
          required
          width={'100%'}
          name="school_city"
          value={formik.values.school_city}
          onChange={formik.handleChange}
        />
      </div>
      {/* <div className="text-fields">
        <TextFields
          label={'School Address'}
          placeholder={'Enter School Address'}
          required
          width={'100%'}
          name="school_address"
          value={formik.values.school_address}
          onChange={formik.handleChange}
        />
        <TextFields
          label={'School City'}
          placeholder={'Enter School City'}
          required
          width={'100%'}
          name="school_city"
          value={formik.values.school_city}
          onChange={formik.handleChange}
        />
      </div> */}
      <div className="text-fields">
        <TextFields
          label={'School State'}
          placeholder={'Enter School State'}
          required
          width={'100%'}
          name="school_state"
          value={formik.values.school_state}
          onChange={formik.handleChange}
        />
        <TextFields
          label={'School Pincode'}
          placeholder={'Enter School Pincode'}
          width={'100%'}
          name="school_pin_code"
          value={formik.values.school_pin_code}
          onChange={formik.handleChange}
        />
      </div>
      <div className="text-fields">
      
        {/* <TextFields
          label={'School Country'}
          placeholder={'Enter School Country'}
          required
          width={'100%'}
          name="school_country"
          value={formik.values.school_country}
          onChange={formik.handleChange}
        /> */}

        <SelectField
          label={'School Country'}
          width={'100%'}
          required
          options={countryOptions}
          value={formik.values.school_country}
          onChange={handleCountryChange}
        />
          <TextFields
          name={'school_country_code'}
          label={'School Country Code'}
          width={'100%'}
          placeholder={'Enter School Country Code'}
          required
          readOnly
          disabled={true}
          value={formik.values.school_country_code}
          onChange={formik.handleChange}
          style={{
            cursor: 'not-allowed'
          }}
        />
      </div>


      <div>
        <Typography mb={2} fontSize={'24px'} fontWeight={500}>
          Admin Information
        </Typography>
        <ImageUpload
          label={'Avatar'}
          selectedImage={
            formik.values.administrationImage &&
            URL.createObjectURL(formik.values.administrationImage)
          }
          onFileChange={(event) => handleFileChange(event, 'administrationImage')}
        />
        <div className="text-fields">
          <TextFields
            name={'adName'}
            label={'Name'}
            placeholder={'Enter Admin Name'}
            width={'100%'}
            required
            value={formik.values.adName}
            onChange={handleStringInputChange('adName')}
          />
          <TextFields
            name={'personalcontact'}
            label={'Contact Number'}
            placeholder={'1234567890'}
            width={'100%'}
            required
            value={formik.values.personalcontact}
            onChange={handleInputChange('personalcontact')}
          />
        </div>

        <div className="text-fields">
          <SelectField
            label={'Gender'}
            width={'90%'}
            required
            options={selectOptions}
            value={formik.values.gender}
            onChange={(value) => formik.setFieldValue('gender', value)}
          />
          <TextFields
            name={'personalEmail'}
            label={'Email'}
            width={'100%'}
            placeholder={'example@gmail.com'}
            required
            value={formik.values.personalEmail}
            onChange={formik.handleChange}
          />
        </div>

        <div className="text-fields">
          <TextFields
            name={'password'}
            label={'Password'}
            placeholder={''}
            width={'100%'}
            required
            value={formik.values.password}
            onChange={formik.handleChange}
          />
        </div>
        <TextFields
          name={'employee_country_code'}
          label={'Employee Country Code'}
          width={'100%'}
          placeholder={'Enter Employee Country Code'}
          value={formik.values.employee_country_code}
          onChange={formik.handleChange}
          disabled={true}
          required
          style={{
            cursor: 'not-allowed'
          }}
        />

        <div className="text-fields">
          <FormControlLabel
            control={
              <Checkbox
                checked={formik.values.is_partner || false}
                onChange={(e) => formik.setFieldValue('is_partner', e.target.checked)}
                color="primary"
                name="is_partner"
              />
            }
            label={<span>Check for Partner</span>}
          />
        </div>
        <div className="text-fields">
          <TextFields
            name={'personalAddress1'}
            label={'Address'}
            width={'100%'}
            placeholder={'Enter Address 1'}
            value={formik.values.personalAddress1}
            onChange={formik.handleChange}
          />
          <TextFields
            name={'personalAddress2'}
            label={'Address 2'}
            placeholder={'Enter Address 2'}
            width={'100%'}
            value={formik.values.personalAddress2}
            onChange={formik.handleChange}
          />
        </div>
        <div className="text-fields">
          <TextFields
            name={'personalCity'}
            label={'City'}
            width={'60%'}
            placeholder={'Enter city'}
            value={formik.values.personalCity}
            onChange={handleStringInputChange('personalCity')}
          />
          <TextFields
            name={'personalState'}
            label={'State'}
            placeholder={'Enter State'}
            width={'170px'}
            value={formik.values.personalState}
            onChange={handleStringInputChange('personalState')}
          />
          <TextFields
            name={'personalZip'}
            label={'Zip Code'}
            width={'170px'}
            placeholder={'XXXXXX'}
            value={formik.values.personalZip}
            onChange={handleInputChange('personalZip')}
          />
        </div>
        <Divider />
        <Typography mt={2} mb={2} fontSize={'20px'} fontWeight={400}>
          Other Information
        </Typography>
        <div className="text-fields">
          <TextFields
            required
            placeholder={'Enter Salary'}
            name={'salary'}
            label={'Salary'}
            width={'50%'}
            value={formik.values.salary}
            onChange={handleInputChange('salary')}
          />
          <DateInput
            required
            width={'50%'}
            label={'Joining Date'}
            value={formik.values.joiningDate}
            name={'joiningDate'}
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="in-a-row" style={{ justifyContent: 'flex-end' }}>
        <Typography className="back-btn" onClick={() => navigate('/dashboard')}>
          Back
        </Typography>

        <StyledButton width={'50%'} onClick={onNext}>
          Submit
        </StyledButton>
      </div>
    </div>
  )
}
const selectOptions = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
]
export const Step2 = ({ formik, handleFileChange, onPrev, onNext }) => {
  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, '')
    formik.setFieldValue(fieldName, numericValue)
  }
  return (
    <div>
      <Typography mb={2} className="form-heading">
        Personal Information
      </Typography>
      <ImageUpload
        label={'Avatar'}
        selectedImage={
          formik.values.administrationImage &&
          URL.createObjectURL(formik.values.administrationImage)
        }
        onFileChange={(event) => handleFileChange(event, 'administrationImage')}
      />
      <div className="text-fields">
        <TextFields
          name={'adName'}
          label={'Name'}
          width={'100%'}
          required
          value={formik.values.adName}
          onChange={formik.handleChange}
        />
        <TextFields
          name={'highestEducation'}
          label={'Highest Education'}
          width={'100%'}
          value={formik.values.highestEducation}
          onChange={formik.handleChange}
        />
      </div>
      <div className="text-fields">
        <DateInput
          label={'Date of Birth'}
          width={'100%'}
          value={formik.values.dateOfBirth}
          name={'dateOfBirth'}
          onChange={formik.handleChange}
        />
        <SelectField
          label={'Gender'}
          width={'90%'}
          options={selectOptions}
          value={formik.values.gender}
          onChange={(value) => formik.setFieldValue('gender', value)}
        />
        <TextFields
          name={'personalEmail'}
          label={'Email'}
          width={'100%'}
          value={formik.values.personalEmail}
          onChange={formik.handleChange}
        />
      </div>
      <div className="text-fields">
        <TextFields
          name={'personalcontact'}
          label={'Contact Number'}
          width={'100%'}
          required
          value={formik.values.personalcontact}
          onChange={handleInputChange('personalcontact')}
        />
        <TextFields
          name={'personaleContact'}
          label={'Emergency Number'}
          width={'100%'}
          required
          value={formik.values.personaleContact}
          onChange={handleInputChange('personaleContact')}
        />
      </div>

      <Divider />
      <Typography mt={2} mb={2} className="form-heading">
        Other Information
      </Typography>
      <div className="text-fields">
        <TextFields
          name={'personalAddress1'}
          label={'Address'}
          width={'100%'}
          value={formik.values.personalAddress1}
          onChange={formik.handleChange}
        />
        <TextFields
          name={'personalAddress2'}
          label={'Address 2'}
          width={'100%'}
          value={formik.values.personalAddress2}
          onChange={formik.handleChange}
        />
      </div>
      <div className="text-fields">
        <TextFields
          name={'personalCity'}
          label={'City'}
          width={'60%'}
          value={formik.values.personalCity}
          onChange={formik.handleChange}
        />
        <TextFields
          name={'personalState'}
          label={'State'}
          width={'170px'}
          value={formik.values.personalState}
          onChange={formik.handleChange}
        />
        <TextFields
          name={'personalZip'}
          label={'Zip Code'}
          width={'170px'}
          value={formik.values.personalZip}
          onChange={handleInputChange('personalZip')}
        />
      </div>
      <Buttons onPrev={onPrev} onNext={onNext} />
    </div>
  )
}

export const Step3 = ({ formik, handleFileChange, onPrev, onNext }) => {
  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, '')
    formik.setFieldValue(fieldName, numericValue)
  }
  return (
    <div>
      <Typography mb={2} className="form-heading">
        Personal Information
      </Typography>
      <ImageUpload
        label={'Avatar'}
        selectedImage={
          formik.values.teacherImage && URL.createObjectURL(formik.values.teacherImage)
        }
        onFileChange={(event) => handleFileChange(event, 'teacherImage')}
      />
      <div className="text-fields">
        <TextFields
          name={'teacherName'}
          label={'Name'}
          width={'100%'}
          required
          value={formik.values.teacherName}
          onChange={formik.handleChange}
        />
        <TextFields
          name={'teacherQual'}
          label={'Highest Education'}
          width={'100%'}
          value={formik.values.teacherQual}
          onChange={formik.handleChange}
        />
      </div>
      <div className="text-fields">
        <DateInput
          label={'Date of Birth'}
          width={'100%'}
          value={formik.values.teacherDOB}
          name={'teacherDOB'}
          onChange={formik.handleChange}
        />
        <SelectField
          label={'Gender'}
          width={'90%'}
          options={selectOptions}
          value={formik.values.teachergender}
          onChange={(value) => formik.setFieldValue('teachergender', value)}
        />
        <TextFields
          name={'teacherEmail'}
          label={'Email'}
          width={'100%'}
          required
          value={formik.values.teacherEmail}
          onChange={formik.handleChange}
        />
      </div>
      <div className="text-fields">
        <TextFields
          name={'teacherContact'}
          label={'Contact Number'}
          width={'100%'}
          required
          value={formik.values.teacherContact}
          onChange={handleInputChange('teacherContact')}
        />
        <TextFields
          name={'teacherEContact'}
          label={'Emergency Number'}
          width={'100%'}
          required
          value={formik.values.teacherEContact}
          onChange={handleInputChange('teacherEContact')}
        />
      </div>

      <Divider />
      <Typography mt={2} mb={2} className="form-heading">
        Other Information
      </Typography>
      <TextFields
        name={'teacherSalary'}
        label={'Salary'}
        required
        value={formik.values.teacherSalary}
        onChange={formik.handleChange}
      />
      <DateInput
        label={'Joining Date'}
        value={formik.values.teacherJoiningDate}
        name={'teacherJoiningDate'}
        onChange={formik.handleChange}
      />
      <div className="text-fields">
        <TextFields
          name={'teacherAddress1'}
          label={'Address'}
          width={'100%'}
          value={formik.values.teacherAddress1}
          onChange={formik.handleChange}
        />
        <TextFields
          name={'teacherAddress2'}
          label={'Address 2'}
          width={'100%'}
          value={formik.values.teacherAddress2}
          onChange={formik.handleChange}
        />
      </div>
      <div className="text-fields">
        <TextFields
          name={'teacherCity'}
          label={'City'}
          width={'60%'}
          value={formik.values.teacherCity}
          onChange={formik.handleChange}
        />
        <TextFields
          name={'teacherState'}
          label={'State'}
          width={'170px'}
          value={formik.values.teacherState}
          onChange={formik.handleChange}
        />
        <TextFields
          name={'teacherZip'}
          label={'Zip Code'}
          width={'170px'}
          value={formik.values.teacherZip}
          onChange={handleInputChange('teacherZip')}
        />
      </div>
      <Buttons onPrev={onPrev} onNext={onNext} />
    </div>
  )
}

export const Step4 = ({ formik, onPrev, onNext }) => {
  const { data: gradeOptions } = useGlobal({ userUrl: urls.GRADE_LIST })
  return (
    <div>
      <p className="textfield-label">School</p>
      <Typography mb={2} className="disabled-text">
        {formik.values.schoolName}
      </Typography>

      <SelectField
        label={'Grade Name'}
        name="grade"
        width={'97%'}
        required
        options={(gradeOptions || [])?.map((prod) => ({
          value: prod.grade_id,
          label: prod.grade,
        }))}
        value={formik.values.grade}
        onChange={(value) => formik.setFieldValue('grade', value)}
      />
      <Buttons onPrev={onPrev} onNext={onNext} />
    </div>
  )
}
const supportStaff = [
  { label: 'Staff 1', value: 'Staff 1' },
  { label: 'Staff 2', value: 'Staff 2' },
]
export const Step5 = ({ onSubmit, handlePrev, formik }) => {
  const { data: gradeOptions } = useGlobal({ userUrl: urls.GRADE_LIST })
  const { data: sectionOptions } = useGlobal({ userUrl: urls.SECTION_LIST })
  const { data: teacherOptions } = useGlobal({ userUrl: `${urls.TEACHER_LIST}` })
  const selectedGradeLabel = gradeOptions?.find(
    (option) => option?.grade_id === formik.values.grade,
  )?.grade
  return (
    <div>
      <p className="textfield-label">School</p>
      <Typography mb={4} className="disabled-text">
        Don Bosco
      </Typography>
      <Typography mb={2} className="disabled-text">
        {selectedGradeLabel}
      </Typography>
      {/* <TextFields
        label={'Grade Name'}
        name={'grade'}
        required
        value={formik.values.grade}
        onChange={formik.handleChange}
      /> */}
      <SelectField
        label={'Section'}
        name={'section'}
        width={'97%'}
        required
        options={(sectionOptions || [])?.map((prod) => ({
          value: prod.section_id,
          label: prod.section,
        }))}
        value={formik.values.section}
        onChange={(value) => formik.setFieldValue('section', value)}
      />
      <SelectField
        name={'primaryTeacher'}
        label={'Primary Teacher'}
        width={'97%'}
        required
        options={(teacherOptions || [])?.map((prod) => ({
          value: prod.employee_id,
          label: prod.employee_name,
        }))}
        value={formik.values.primaryTeacher}
        onChange={(value) => formik.setFieldValue('primaryTeacher', value)}
      />
      <SelectField
        name={'secTeacher'}
        label={'Secondary Teacher'}
        width={'97%'}
        required
        options={(teacherOptions || [])?.map((prod) => ({
          value: prod.employee_id,
          label: prod.employee_name,
        }))}
        value={formik.values.secTeacher}
        onChange={(value) => formik.setFieldValue('secTeacher', value)}
      />
      {/* <TextFields
        name={'secTeacher'}
        label={'Secondary Teacher'}
        required
        value={formik.values.secTeacher}
        onChange={formik.handleChange}
      /> */}
      <SelectField
        label={'Support Staff'}
        width={'100%'}
        required
        options={supportStaff}
        value={formik.values.supportStaff}
        onChange={(value) => formik.setFieldValue('supportStaff', value)}
      />
      <div className="in-a-row" style={{ justifyContent: 'flex-end' }}>
        <Typography className="back-btn" onClick={handlePrev}>
          Back
        </Typography>

        <StyledButton width={'50%'} onClick={onSubmit}>
          Finish
        </StyledButton>
      </div>
    </div>
  )
}

export const SuccessBox = ({ formik, student, children, close, handleQR }) => {
  const navigate = useNavigate()
  const handleClose = () => {
    if (student) {
      close()
    } else {
      navigate('/dashboard')
    }
  }
  return (
    <div className="registration-box" style={{ width: '440px' }}>
      <div className="admin-added">
        <CommonSuccess />
        <div style={{ width: '100%' }}>
          <Typography mt={2} className="grey-text" fontSize={'14px'} textAlign={'left'}>
            {student ? 'STUDENT' : 'SCHOOL'} INFORMATION
          </Typography>
        </div>
        <Box mt={0} className="admin-info">
          {children}
          {!student && (
            <div className="school-info">
              {formik.values.personalImage ? (
                <img
                  src={
                    formik.values.personalImage && URL.createObjectURL(formik.values.personalImage)
                  }
                  alt=""
                  style={{ width: 90, height: 90, borderRadius: '50%' }}
                />
              ) : (
                <Avatar alt={''} sx={{ width: '76px', height: '76px', fontSize: '24px' }}>
                  {formik.values.schoolName?.charAt(0).toUpperCase()}
                </Avatar>
              )}
              <div>
                <Typography fontSize={'20px'} fontWeight={700}>
                  {formik.values.schoolName}
                </Typography>
                <div className="display-det">
                  <img src={phoneIcon} alt="" />
                  <Typography className="grey-text" fontSize={'16px'}>
                    {formik.values.contactNumber}
                  </Typography>
                </div>
              </div>
            </div>
          )}
        </Box>
        {!student && <CloseCommonSuccess handleClose={handleClose} hnhleOpen={handleQR} />}
      </div>
    </div>
  )
}
export const CommonSuccess = () => {
  return (
    <>
      <img src={SuccesAnimation} alt="" className="success-animation" />
      <Typography fontSize={'24px'} fontWeight={700}>
        Setup Completed!
      </Typography>
      <Typography fontSize={'16px'}>
        Your account setup is finished, making it simple to monitor student attendance effortlessly.
      </Typography>
    </>
  )
}
export const CloseCommonSuccess = ({ handleClose, hnhleOpen }) => {
  return (
    <>
      <StyledButton onClick={handleClose}>Okay</StyledButton>
      <div className="download-block">
        <img src={QRicon} alt="" />
        <Typography className="download-qr" onClick={hnhleOpen}>
          Download QR Code
        </Typography>
      </div>
    </>
  )
}

export const QRCodeDisplay = ({ open, handleClose, value, name }) => {
  const dispatch = useDispatch()
  const qrCodeRef = React.useRef(null)

  const handleDownloadPDF = async () => {
    dispatch(setLoader(true))
    const input = qrCodeRef.current
    try {
      const canvas = await html2canvas(input, {
        scale: 5,
        logging: false,
        scrollY: -window.scrollY,
        windowWidth: document.documentElement.offsetWidth,
        windowHeight: document.documentElement.offsetHeight,
        useCORS: true,
      })
      const imgData = canvas.toDataURL('route')
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: 'a4',
      })

      const width = pdf.internal.pageSize.getWidth()
      const height = (canvas.height * width) / canvas.width
      pdf.addImage(imgData, 'PNG', 0, 0, width, height)
      pdf.save(`${name}.pdf`)
      dispatch(setLoader(false))
    } catch (error) {
      console.error('Error Generating Pdf:', error)
      dispatch(setLoader(false))
    }
  }

  return (
    <ModalWrapper open={open} handleClose={handleClose} title={'QRCode'}>
      <div ref={qrCodeRef} style={{ padding: '10px' }}>
        <QRCode value={value.toString()} />
        <Typography sx={{ fontSize: '14px', textAlign: 'center' }}>NAME: {name}</Typography>
      </div>
      <StyledButton onClick={handleDownloadPDF}>Download as PDF</StyledButton>
    </ModalWrapper>
  )
}
